import $ from 'jquery';
import ymaps from 'ymaps';

export default function () {
  const layout = ymaps.templateLayoutFactory.createClass(`
    <div class="balloon">
      <div class="balloon__arrow"></div>
      <div class="balloon__content">
        $[[options.contentLayout observeSize]]
      </div>
    </div>
  `, {
    build() {
      this.constructor.superclass.build.call(this);
      this._$element = $('.balloon', this.getParentElement());
      this.applyElementOffset();
    },
    clear() {
      this.constructor.superclass.clear.call(this);
    },
    onSublayoutSizeChange(...args) {
      layout.superclass.onSublayoutSizeChange.apply(this, args);

      if (!this._isElement(this._$element)) {
        return;
      }

      this.applyElementOffset();
      this.events.fire('shapechange');
    },
    applyElementOffset() {
      this._$element.css({
        left: -(this._$element[0].offsetWidth / 2),
        top: -(this._$element[0].offsetHeight + (this._$element.find('.balloon__arrow')[0].offsetHeight / 2))
      });
    },
    getShape() {
      if (!this._isElement(this._$element)) {
        return layout.superclass.getShape.call(this);
      }

      const position = this._$element.position();

      return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
        [position.left, position.top],
        [
          position.left + this._$element[0].offsetWidth,
          position.top + this._$element[0].offsetHeight + this._$element.find('.balloon__arrow')[0].offsetHeight
        ]
      ]));
    },
    _isElement(element) {
      return element && element[0] && element.find('.balloon__arrow')[0];
    }
  });

  return layout;
}
